import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useBookingPaymentCards_session$key } from "./__generated__/useBookingPaymentCards_session.graphql";

/** Eligible cards for this club, with User cards first to preserve default preference. */
export const useBookingPaymentCards = (
  sessionRef: useBookingPaymentCards_session$key | null | undefined,
  bookingDate: string | null | undefined
) => {
  const session = useFragment(
    useBookingPaymentCardsSessionFragmentString,
    sessionRef
  );
  const [year, month] = (bookingDate ?? "").split("-").map(Number);
  const edges = [
    ...(session?.user?.squareCards?.edges ?? []),
    ...(session?.currentClientProfile?.member?.squareCards?.edges ?? []),
  ];
  const seen = new Set<string>();

  return edges.flatMap((edge) => {
    const card = edge?.node;
    if (
      !card?.enabled ||
      !year ||
      !month ||
      !card.expYear ||
      !card.expMonth ||
      card.expYear < year ||
      (card.expYear === year && card.expMonth < month) ||
      seen.has(card.id)
    ) {
      return [];
    }
    seen.add(card.id);
    return [card];
  });
};

const useBookingPaymentCardsSessionFragmentString = graphql`
  fragment useBookingPaymentCards_session on Session
  @argumentDefinitions(bookingDate: { type: "Date!" }) {
    user {
      ... on MemberUser {
        squareCards(enabled: true, validOnDate: $bookingDate) {
          edges {
            node {
              id
              enabled
              default
              expMonth
              expYear
              ...SquareCardFragment
            }
          }
        }
      }
    }
    currentClientProfile {
      member {
        ... on Customer {
          squareCards(enabled: true, validOnDate: $bookingDate) {
            edges {
              node {
                id
                enabled
                default
                expMonth
                expYear
                ...SquareCardFragment
              }
            }
          }
        }
      }
    }
  }
`;
